import React, {Component} from "react";
import {Grid, Row, Col, FormGroup, ControlLabel, FormControl, InputGroup} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { css } from "@emotion/core";
import {ScaleLoader} from 'react-spinners';
import Button from "../../components/CustomButton/CustomButton";
import Switch from "react-bootstrap-switch";
import axios from "axios";
import {Redirect} from "react-router";
import connect from "react-redux/es/connect/connect";
import {userActions} from "../../authentication/_actions";
import ModalSave from "../../components/CustomModals/ModalSave";
import {withNamespaces} from "react-i18next";
import NotificationSystem from "react-notification-system";
import {style} from "../../variables/Variables";

const override = css`
    position: fixed;
    left: 50%;
    top: 35%;
    display: block;
    z-index: 1000;
    height: 31px;
    width: 100px;
    `;

class EditTvodPriceGroup extends Component {

    constructor(props) {
        super(props);

        this.state = {

            loading: false,
            redirect: false,
            tvodRedirect: false,

            back_button_text: "Back",
            showSaveModal: false,

            tvodPriceGroupArray: [],

            vpgroup_description: null,
            vpgroup_duration: null,
            vpgroup_id: null,
            vpgroup_name: null,
            vpgroup_price: null,
            vpgroup_status: null,

            statusSwitch: false,

            _notificationSystem: null

        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleSwitch(elem, state) {


        if (elem.props.name === 'statusSwitch') {
            this.setState({statusSwitch: state})
        }
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentDidMount() {

        this.setState({_notificationSystem: this.refs.notificationSystem})

        const {handle} = this.props.match.params

        if (handle === 'new') {
            this.setState({loading: false, back_button_text: "cancel", vpgroup_name: null, vpgroup_id: 0})
        } else {

            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {'X-Id-Token': token}
            };

            let dataUrl = process.env.REACT_APP_API_URL + "/PriceGroupTvod/" + handle;

            axios.get(dataUrl, axiosConfig).then(response => {
                const tvodPriceGroupArray = response.data[0];
                //console.log(tvodPriceGroupArray);

                let statusSwitch = tvodPriceGroupArray.vpgroup_status === 1 ? true : false

                this.setState({
                        tvodPriceGroupArray,
                        statusSwitch,
                        loading: false,
                        vpgroup_description: tvodPriceGroupArray.vpgroup_description,
                        vpgroup_duration: tvodPriceGroupArray.vpgroup_duration,
                        vpgroup_id: tvodPriceGroupArray.vpgroup_id,
                        vpgroup_name: tvodPriceGroupArray.vpgroup_name,
                        vpgroup_price: tvodPriceGroupArray.vpgroup_price,
                        //vpgroup_status: tvodPriceGroupArray.vpgroup_status
                    }
                );

            })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                    this.props.dispatch(userActions.logoutUnauthorized());
                });
        }


    }

    createTvodPriceGroup() {

        const url = process.env.REACT_APP_API_URL + "/PriceGroupTvod";

        let statusSwitch = this.state.statusSwitch === true ? 1 : 0

        var postData = {
            tvod_group: {
                vpgroup_description: this.state.vpgroup_description,
                vpgroup_duration: this.state.vpgroup_duration,
                vpgroup_name: this.state.vpgroup_name,
                vpgroup_price: this.state.vpgroup_price,
                vpgroup_status: statusSwitch
            }
        };


        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        axios.post(url, postData, axiosConfig)
            .then((res) => {

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    this.setState({loading: false})
                    const tvodPriceGroupArray = res.data;
                    this.setState({vpgroup_id: tvodPriceGroupArray.vpgroup_id})
                    this.setTvodPriceGroupRedirect();
                    this.notification("success")
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    updateTvodPriceGroup() {


        const {handle} = this.props.match.params
        const url = process.env.REACT_APP_API_URL + "/PriceGroupTvod/" + handle;

        let statusSwitch = this.state.statusSwitch === true ? 1 : 0

        // Send a PUT request
        var postData = {
            tvod_group: {
                vpgroup_description: this.state.vpgroup_description,
                vpgroup_duration: this.state.vpgroup_duration,
                vpgroup_id: this.state.vpgroup_id,
                vpgroup_name: this.state.vpgroup_name,
                vpgroup_price: this.state.vpgroup_price,
                vpgroup_status: statusSwitch
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        axios.put(url, postData, axiosConfig)
            .then((res) => {

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    this.setState({loading: false})
                    this.notification("success")
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    cancelTvodGroupEdit() {
        this.setRedirect()
    }

    setTvodPriceGroupRedirect = () => {
        this.setState({
            tvodRedirect: true,
            back_button_text: "Back"
        })
    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        let path = "/pricing/tvod-price";
        let pathTvod = "/edit-tvod-price/" + this.state.vpgroup_id;

        if (this.state.redirect) {
            this.setState({redirect: false, tvodRedirect: false})
            return <Redirect push to={path}/>
        }

        if (this.state.tvodRedirect) {
            this.setState({redirect: false, tvodRedirect: false})
            return <Redirect push to={pathTvod}/>
        }
    }

    setSaveModal = (value, action) => {

        this.setState({
            showSaveModal: value

        })

        if (action === "save") {
            this.setState({loading: true})

            const {handle} = this.props.match.params

            if (handle === 'new') {
                this.createTvodPriceGroup();
            } else {
                this.updateTvodPriceGroup();
            }
        }
    }

    renderSaveModal = () => {

        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"TVOD Price Group: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.vpgroup_id === 0 ? '' : this.state.vpgroup_id}
            />
        }

    }

    notification(status) {

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>Channel Category has been updated</b>
                    </div>
                ),
                level: 'success',
                position: 'tr',
                autoDismiss: 5,
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>failed to update Category</b>
                    </div>
                ),
                level: 'error',
                position: 'tr',
                autoDismiss: 10,
            });
        }

    }

    title() {
        if (this.state.vpgroup_name === null) {
            return "New - TVOD Price Configuration";
        } else {
            return this.state.vpgroup_name + " -  TVOD Price Configuration";
        }
    }

    render() {
        return (
            <div className="main-content">

                <NotificationSystem ref="notificationSystem" style={style}/>

                {this.renderRedirect()}
                {this.renderSaveModal()}


                <div className="sweet-loader">
                    <ScaleLoader
                        css={override}
                        color={'#797979'}
                        loading={this.state.loading}
                    />
                </div>

                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                title={this.title()}
                                content={
                                    <div>
                                        <FormGroup>
                                            <p className="category">Status</p>
                                            <Switch
                                                name={"statusSwitch"}
                                                disabled={this.state.loading}
                                                value={this.state.statusSwitch}
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>ID</ControlLabel>
                                            <FormControl placeholder="vpgroup_id"
                                                         type="number"
                                                         name={"vpgroup_id"}
                                                         disabled
                                                         value={this.state.vpgroup_id || ''}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Name</ControlLabel>
                                            <FormControl placeholder="Enter Name"
                                                         type="text"
                                                         name={"vpgroup_name"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.vpgroup_name || ''}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Price <code>(USD)</code></ControlLabel>
                                            <InputGroup>
                                                <InputGroup.Button>
                                                    <Button fill default><i
                                                        className="fa fa-dollar"/></Button>
                                                </InputGroup.Button>
                                                <FormControl placeholder="Enter price"
                                                             type="text"
                                                             name="vpgroup_price"
                                                             disabled={this.state.loading}
                                                             onChange={this.handleInputChange}
                                                             value={this.state.vpgroup_price || ""}
                                                />
                                            </InputGroup>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Duration <code>(Hours)</code> </ControlLabel>
                                            <InputGroup>
                                                <InputGroup.Button>
                                                    <Button fill twitter><i
                                                        className="fa fa-clock-o"/></Button>
                                                </InputGroup.Button>
                                                <FormControl placeholder="Enter duration"
                                                             type="text"
                                                             name="vpgroup_duration"
                                                             disabled={this.state.loading}
                                                             onChange={this.handleInputChange}
                                                             value={this.state.vpgroup_duration || ""}
                                                />
                                            </InputGroup>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Description</ControlLabel>
                                            <FormControl componentClass="textarea"
                                                         type="text"
                                                         rows={4}
                                                         name="vpgroup_description"
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         placeholder="Enter the description"
                                                         value={this.state.vpgroup_description || ''}
                                            />
                                        </FormGroup>

                                    </div>
                                }
                                ftTextCenter
                                legend={
                                    <div className="buttons-with-margin">
                                        <Button bsStyle="info" fill wd
                                                name={"saveButton"}
                                                disabled={this.state.loading}
                                                onClick={() => this.setState({showSaveModal: true})}
                                        >
                                            Save
                                        </Button>
                                        <Button bsStyle="default" fill wd
                                                name={"cancelButton"}
                                                disabled={this.state.loading}
                                                onClick={this.cancelTvodGroupEdit.bind(this)}>
                                            {this.state.back_button_text}
                                        </Button>
                                    </div>
                                }
                            />
                        </Col>

                    </Row>
                </Grid>

            </div>
        );
    }
}

function mapStateToProps(state) {

    const {users, authentication} = state;
    const {user} = authentication;
    return {
        user,
        users
    };
}

const connectedEditTvodPriceGroup = connect(mapStateToProps)(EditTvodPriceGroup);
const connectedEditTvodPriceGroupTrans = withNamespaces('common')(connectedEditTvodPriceGroup);
export {connectedEditTvodPriceGroupTrans as EditTvodPriceGroup};
